const checkboxFields = document.querySelectorAll('.node-daily-commute-inline-creation-form .form-checkboxes');

checkboxFields.forEach(field => {
  const checkboxes = field.querySelectorAll('input[type="checkbox"]');
  const checkboxWrappers = field.querySelectorAll('.form-item');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const selectedCheckboxes = field.querySelectorAll('input[type="checkbox"]:checked');
      const maxAllowed = 2;

      if (selectedCheckboxes.length >= maxAllowed) {
        checkboxes.forEach(cb => {
          if (!cb.checked) {
            cb.disabled = true;
            const parentWrapper = cb.closest('.form-item');
            if (parentWrapper) {
              parentWrapper.classList.add('disabled');
            }
          }
        });
      } else {
        checkboxes.forEach(cb => {
          cb.disabled = false;
          const parentWrapper = cb.closest('.form-item');
          if (parentWrapper) {
            parentWrapper.classList.remove('disabled');
          }
        });
      }
    });
  });
});

// handle password toggler
const passwordElements = document.querySelectorAll('.js-form-type-password');
passwordElements.forEach(element => {
  const eyeIcon = document.createElement('span');
  eyeIcon.classList.add('icon--eye', 'toggle-password');
  eyeIcon.setAttribute('toggle', '#password-field');
  element.appendChild(eyeIcon);

  eyeIcon.addEventListener('click', function() {
    this.classList.toggle('eye--close');
    const input = element.querySelector('input');

    if (input.getAttribute('type') === 'password') {
      input.setAttribute('type', 'text');
    } else {
      input.setAttribute('type', 'password');
    }
  });
});

// Function to check if both checkbox fields of a specific form instance have values selected
function checkCheckboxFields(form) {
  const checkboxFields = form.querySelectorAll('.form-checkboxes');

  let isField1Checked = false;
  let isField2Checked = false;

  checkboxFields.forEach((field, index) => {
    const checkboxes = field.querySelectorAll('input[type="checkbox"]:checked');
    if (index === 0 && checkboxes.length > 0) {
      isField1Checked = true;
    } else if (index === 1 && checkboxes.length > 0) {
      isField2Checked = true;
    }
  });

  return isField1Checked && isField2Checked;
}


function handleButtonState(form) {
  const saveButton = form.querySelector('[data-drupal-selector="edit-submit"]'); 

  if (checkCheckboxFields(form)) {
    saveButton.disabled = false;
  } else {
    saveButton.disabled = true;
  }
}

const forms = document.querySelectorAll('.node-daily-commute-inline-creation-form');
forms.forEach(form => {
  const checkboxes = form.querySelectorAll('.form-checkboxes input[type="checkbox"]');
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      handleButtonState(form);
    });
  });

  handleButtonState(form);
});
